export enum GtagSearchType {
    /**
     * Main site search
     */
    SITE = 'SITE',
    /**
     * Term search on the all-products page
     */
    ALL_PRODUCTS_TERM = 'ALL_PRODUCTS_TERM',
    /**
     * Category search on the all-products page
     */
    ALL_PRODUCTS_CATEGORY = 'ALL_PRODUCTS_CATEGORY'
}
